class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.el = this;
        this.display = this.querySelector('[data-time-display]');
        this.passwordForm = this.querySelector('[data-password-form]');
        this.block = this.closest('.countdown__block--timer');
        this.templateId = this.el.dataset.templateId;
        this.year = this.el.dataset.year;
        this.month = this.el.dataset.month;
        this.day = this.el.dataset.day;
        this.hour = this.el.dataset.hour;
        this.minute = this.el.dataset.minute;
        this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
        this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
        this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
        this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
        this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
        this.hideTimerOnComplete = this.el.dataset.hideTimer;
        this.completeMessage = this.el.dataset.completeMessage;
        this.showPassword = this.el.dataset.showPassword;
        this.fullPassword = this.el.dataset.fullPassword;
        this.fullPasswordBlock = null;
        this.password = this.el.dataset.password;
        this.expiry = this.el.dataset.expiry;
        this.basic = !!this.el.dataset.basic;
        this.sticky = this.el.hasAttribute('data-sticky') ? true : false;

        this.timerComplete = false;

        this.init();
    }

    async init() {
        if (!this.basic && await this._checkCookie(`ehp_${this.templateId}_access`)) {
            const promoWidget = document.querySelector('.promotional-widget');
            promoWidget?.classList.remove('initial');
            const initPromoContent = document.querySelectorAll('.vault-promotions__init-content');
            if (initPromoContent) {
                initPromoContent.forEach(elem => {
                    elem.classList.add('hidden');
                })
            }
            this._openVault(false, this.templateId);
            return;
        };

        if (this.fullPassword) {
            const fullPasswordBlock = document.querySelector('.countdown__block--password');
            if (fullPasswordBlock) {
                this.fullPasswordBlock = fullPasswordBlock;
                this.passwordForm = fullPasswordBlock;
            }
        }

        this.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        })

        // Stick to top
        if (this.sticky) {
            setTimeout(() => {
                this._stickyTimer(true);
            }, 1500); // ensure timer has started to get appropriate width
        }

        setInterval(() => {
            if (!this.timerComplete) {
                this._calculate();
            }
        }, 1000);

        if (this.passwordForm) {
            const submit = this.passwordForm.querySelector('button');
            submit.addEventListener('click', (e) => {
                const input = this.passwordForm.querySelector('input');

                if (input.value === this.password) {
                    this._addAccessFlag(this.templateId);

                    this._openVault(true, this.templateId);
                } else {
                    // Remove previous error message
                    const prevError = this.passwordForm.querySelector('.countdown__password-error');
                    if (prevError) {
                        this.passwordForm.removeChild(prevError);
                    }
                    // Add error message
                    const errorMessage = document.createElement('span');
                    errorMessage.classList.add('countdown__password-error')
                    errorMessage.innerHTML = "Incorrect Password";
                    this.passwordForm.appendChild(errorMessage);
                }
            })
        }
    }

    _stickyTimer(setSticky) {
        const wrapper = this.closest('.sticky');
        if (!wrapper) return;

        if (wrapper.offsetParent === null) return; // ensure element is visible before running

        if (setSticky) {
            let topTrigger, leftPos, pageWidth;

            function calcMetrics() {
                const rect = wrapper.getBoundingClientRect();
                topTrigger = rect.top + window.pageYOffset;
                leftPos = rect.left;
                pageWidth = window.innerWidth;
            }

            calcMetrics();
            window.addEventListener('resize', calcMetrics);
            window.addEventListener('scroll', () => {
                const timerComplete = this.timerComplete;
                if (timerComplete) return;
                const scrollY = window.pageYOffset;

                const stickyHeader = document.querySelector('sticky-header');
                let headerHeight = 0;
                if (stickyHeader) {
                    const rect = stickyHeader.getBoundingClientRect();
                    headerHeight = Math.max(0, rect.bottom);
                }

                if (scrollY >= topTrigger) {
                    let left = pageWidth < 769 ? '50%' : `${leftPos}px`;
                    let transform = pageWidth < 769 ? 'translateX(-50%)' : 'unset';
                    if (this.basic) {
                        left = '50%';
                        transform = 'translateX(-50%)';
                    }
                    Object.assign(wrapper.style, {
                        position: 'fixed',
                        top:      `${0 + headerHeight}px`,
                        left:     left,
                        transform: transform,
                        width:    'max-content'
                    });
                } else {
                    Object.assign(wrapper.style, {
                        position: 'sticky',
                        top:      '0px',
                        left:     'unset',
                        transform: 'unset',
                        width:    'unset'
                    });
                }
            });
        } else {
            wrapper.classList.remove('sticky');

            Object.assign(wrapper.style, {
                position: 'relative',
                top:      'unset',
                left:     'unset',
                transform: 'unset',
                width:    'unset'
            });
        }
    }

    _splitNum(num) {
        const numArr = (`${num}`).split('');
        let html = '';
        numArr.forEach(num => {
            html += `<span>${num}</span>`
        })
        return html;
    }

    _calculate() {
        // Find time difference and convert to integer
        const pad = n => String(n).padStart(2, "0");

        const iso = `${this.year}-${pad(this.month)}-${pad(this.day)}` + `T${pad(this.hour)}:${pad(this.minute)}:00Z`;
        const timeDifference = new Date(iso).getTime() - Date.now();

        if (timeDifference > 0) {
            const intervals = {
                days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((timeDifference / 1000 / 60) % 60),
                seconds: Math.floor((timeDifference / 1000) % 60),
            };
            if (intervals.days < 10) {
                intervals.days = `0${intervals.days}`;
            }
            if (intervals.hours < 10) {
                intervals.hours = `0${intervals.hours}`;
            }
            if (intervals.minutes < 10) {
                intervals.minutes = `0${intervals.minutes}`;
            }
            if (intervals.seconds < 10) {
                intervals.seconds = `0${intervals.seconds}`;
            }

            this.daysPlaceholder.innerHTML = this._splitNum(intervals.days);
            this.hoursPlaceholder.innerHTML = this._splitNum(intervals.hours);
            this.minutesPlaceholder.innerHTML = this._splitNum(intervals.minutes);
            this.secondsPlaceholder.innerHTML = this._splitNum(intervals.seconds);
        } else {
            if (this.completeMessage && this.messagePlaceholder) {
                this.messagePlaceholder.classList.add('countdown__timer-message--visible');
            }

            if (this.hideTimerOnComplete === 'true') {
                this.display.classList.remove('countdown__display--visible');
                this.display.classList.add('countdown__display--hidden');
            }

            if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
                this.block.classList.add('countdown__block--hidden');
            }

            if (this.showPassword === 'true') {
                this.block.classList.add('countdown__password--visible');
            }

            if (this.fullPassword === 'true' && this.fullPasswordBlock) {
                this.fullPasswordBlock.classList.remove('hidden');
            }

            this.timerComplete = true;

            // remove sticky timer
            this._stickyTimer(false);
        }
    }

    _setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=None; Secure";
    }

    async _checkCookie(cname) {
        let name = await this._getCookie(cname);
        if (name != "") {
            return true
        }
        return false;
    }

    async _getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    _addAccessFlag(vaultId) {
        this._setCookie(`ehp_${vaultId}_access`, "true", this.expiry)
    }

    _playVideo(videoElement) {
        const videoWrapper = videoElement.closest('.vault__video');
        videoWrapper.classList.add('show');
        videoElement.muted = true;
        videoElement.play()
            .then(() => {
                // Video starts playing
            })
            .catch((error) => {
                console.error('Error attempting to play video:', error);
            });
    }

    _openVault(showMedia, vaultId) {
        if (showMedia) {
            const videoElements = document.querySelectorAll('.vault__video video');
            const screenWidth = window.innerWidth;

            if (videoElements.length === 2) {
                videoElements.forEach(videoElement => {
                    const isMobile = !!videoElement.closest('.desktop--hide');
                    const isDesktop = !!videoElement.closest('.mobile--hide');

                    if (isMobile && screenWidth <= 768) {
                        this._playVideo(videoElement)
                    }
                    if (isDesktop && screenWidth > 768) {
                        this._playVideo(videoElement)
                    }
                })
            }
            if (videoElements.length === 1) {
                videoElements.forEach(videoElement => {
                    this._playVideo(videoElement)
                })
            }

            // Show promo popup with full content
            const stickyPromoSection = document.querySelector('.sticky-promotion-section');
            if (stickyPromoSection) {
                stickyPromoSection.classList.add('open');
            }

            const widget = stickyPromoSection?.querySelector('.promotional-widget');
            if (widget) {
                widget.classList.add('open');
            }

            const giftDetails = widget?.querySelector('.gift-section--details');
            if (giftDetails) {
                giftDetails.classList.remove('hidden');
            }

            const detailsAccordion = document.querySelector('.gift-section--details');
            if (detailsAccordion) {
              const visibleContainers = document.querySelectorAll('.gift-container');
              if (visibleContainers.length > 0) {
                detailsAccordion.classList.remove('hidden')
              }
            }

            const initPromoContent = document.querySelectorAll('.vault-promotions__init-content');
            if (initPromoContent) {
                initPromoContent.forEach(elem => {
                    elem.classList.remove('hidden');
                })
            }

            const checkoutBtn = document.querySelector('.promotional-widget .checkout');
            if (checkoutBtn) {
                checkoutBtn.classList.add('hidden');
            }
        }

        const collectionBanner = document.querySelector('.section-collection-banner');
        if (collectionBanner) {
            collectionBanner.classList.add('reveal');
        }

        const productGrid = document.querySelector('.section-product-grid');
        if (productGrid) {
            productGrid.classList.add('reveal');
        }

        const closedSections = document.querySelectorAll('.vault--closed');
        closedSections.forEach(section => {
            section.classList.add('hidden');
        })

        const appBlocks = document.querySelectorAll('.shopify-app-block');
        appBlocks.forEach(block => {
            parent = block.closest('section');
            if (parent) {
                parent.classList.add('hidden');
            }
        })

        const openSections = document.querySelectorAll('.vault--open');
        openSections.forEach(section => {
            section.classList.remove('hidden');
        })

        const main = document.querySelector('main');
        if (main) {
            main.classList.add('vault-open');
        }

        // Run sticky countdown again
        if (this.sticky) {
            setTimeout(() => {
                this._stickyTimer(true);
            }, 1500); // ensure timer has started to get appropriate width
        }
    }
}

customElements.define('countdown-timer', CountdownTimer);

class Counter extends HTMLElement {
    constructor() {
        super();
        this.el = this;
        this.display = this.querySelector('[data-counter-display]');
        this.block = this.closest('.counter__block--counter');
        this.year = this.el.dataset.year;
        this.month = this.el.dataset.month;
        this.day = this.el.dataset.day;
        this.hour = this.el.dataset.hour;
        this.minute = this.el.dataset.minute;
        this.rate = this.el.dataset.rate;
        this.addition = this.el.dataset.addition;
        this.text = this.el.dataset.text;
        this.countdownBlock = this.el.dataset.countdownBlock

        this.randomInterval = 1000;

        this.init();
    }

    init() {
        this._calculate();

        setTimeout(() => {
            this._scheduleNextUpdate();
        }, 1000);
    }

    _scheduleNextUpdate() {
        this.randomInterval = (Math.floor(Math.random() * 5) + 1) * 1000;

        setTimeout(() => {
            this._calculate();
            this._scheduleNextUpdate();
        }, this.randomInterval)
    }

    _calculate() {
        const epochTime = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime();
        const now = +new Date().getTime();

        const timeDifference = now - epochTime; // milliseconds

        if (timeDifference < 0) return;

        const elapsedSeconds = Math.floor(timeDifference / 1000);

        let count = 0 + +this.addition;
        count += Math.floor(elapsedSeconds * (this.rate / 60 / 60));

        const countString = `${count}`;

        let countArr = countString.split('');

        while (countArr.length < 7) {
            countArr.unshift('0');
        }

        const currValElems = this.display.querySelectorAll('.counter-digit');
        let currVals = [];
        if (currValElems) {
            currValElems.forEach((elem) => {
                currVals.push(elem.getAttribute('data-val'));
            })
        }

        let html = '';

        html += '<div>'
        const charLen = countArr.length;
        countArr.forEach((char, index) => {
            html += `
                <span data-val="${char}" class="counter-digit">${currVals && currVals[index] && char != currVals[index] ? '<span class="fadeInUp-animation">' + char + '</span>' : char}${this.countdownBlock && this.countdownBlock == 'true' && index + 1 != charLen && (charLen - index - 1) % 3 == 0 ? ','  : ''}</span>
            `;
        })
        html += '</div>'

        if (this.text && this.text != "") {
            html += `<span class="trailing-text">${this.text}</span>`;
        }

        this.display.innerHTML = html;
    }
}
customElements.define('custom-counter', Counter);

// Bundle ATC Modal

// CACHE THESE
const modal       = document.getElementById('product-modal');
const overlay     = modal && modal.querySelector('.modal-overlay');
const closeBtn    = modal && modal.querySelector('.modal-close');
const modalBody   = modal && modal.querySelector('#modal-body');

// OPEN/CLOSE HELPERS
function openModal() {
  document.body.classList.add('modal-open');
  modal.classList.remove('hidden');
}
function closeModal() {
  modal.classList.add('hidden');
  // Handle bundle drawers in popup
  modal.querySelectorAll('.radio-button-wrapper.open').forEach(wrapper => {
    wrapper.classList.remove('open');
  })
  document.body.classList.remove('bundle-drawer-open');
  document.body.classList.remove('modal-open');
}
overlay && overlay.addEventListener('click', closeModal);
closeBtn && closeBtn.addEventListener('click', closeModal);

// RE-BIND THE FORM INSIDE THE MODAL
function initProductForm(container) {
    const form = container.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', async e => {
        // This is being handled by the normal form, do not need to reinit here.
        // We are just running the blow code to auto close the modal
        e.preventDefault();
        const data = new FormData(form);
        // const res  = await fetch('/cart/add.js', {
        const res  = await fetch('/cart', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: null
        });

        if (res.ok) {
            // Optionally: update your cart count UI here
            closeModal();
            // alert('✅ Added to cart');
        } else {
            // const err = await res.json();
            // alert(err.description || '❌ Could not add to cart');
            closeModal();
        }
    });
}

async function fetchProductInfoFragment(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const infoEl = doc.querySelector('section[id^="MainProduct-"]');
    return infoEl ? infoEl.outerHTML : '';
}

function updateModalSoldOutButtons(root) {
    const productModal = document.getElementById('product-modal');
    if (!productModal || !root || !productModal.contains(root)) return;

    const soldOutLabel = window.variantStrings?.soldOut || 'Sold Out';

    root.querySelectorAll('#AddToCart').forEach((wrapper) => {
        const addBtn = wrapper.querySelector('.product-form__submit');
        if (!addBtn) return;

        let soldOutBtn = wrapper.querySelector('[data-modal-sold-out-btn]');
        const notify = wrapper.querySelector('.klaviyo-bis-trigger');
        const isSoldOut = addBtn.classList.contains('hidden');

        if (isSoldOut) {
            if (notify) {
                notify.classList.add('hidden');
                notify.setAttribute('aria-hidden', 'true');
            }
            if (!soldOutBtn) {
                soldOutBtn = document.createElement('button');
                soldOutBtn.type = 'button';
                soldOutBtn.disabled = true;
                soldOutBtn.dataset.modalSoldOutBtn = 'true';
                soldOutBtn.className = 'button button--full-width button--primary button--out-of-stock';
                soldOutBtn.innerHTML = `<span>${soldOutLabel}</span>`;
                wrapper.appendChild(soldOutBtn);
            } else {
                const label = soldOutBtn.querySelector('span');
                if (label) label.textContent = soldOutLabel;
            }
        } else {
            soldOutBtn?.remove();
        }
    });
}

window.updateModalSoldOutButtons = updateModalSoldOutButtons;

function setModalContent(container, html) {
    container.innerHTML = html;

    container.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');

        Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
        });

        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });

    document.dispatchEvent(new Event('select:init'));
    updateModalSoldOutButtons(container);
}

async function openProductCardModal(btn) {
    if (!btn) return;

    const handle = btn.dataset?.handle;
    if (!handle) return;

    const variantId = btn.dataset?.variantId;
    const isAtcButton = btn instanceof Element && btn.matches('button, [data-product-card-modal-trigger], .add-bundle-to-cart');
    if (variantId && isAtcButton && typeof window.addVariantToCartFromCard === 'function') {
        await window.addVariantToCartFromCard(btn, variantId);
        return;
    }

    const loader = isAtcButton ? btn.querySelector('span') : null;
    const originalLabel = btn.dataset?.buttonLabel || (loader ? loader.textContent.trim() : '');
    if (loader) {
        loader.textContent = '';
        loader.classList.add('bundle-atc-loader');
    }

    const url = `/products/${handle}`;
    const container = document.querySelector('#product-modal');
    if (!container) {
        if (loader) {
            loader.textContent = originalLabel;
            loader.classList.remove('bundle-atc-loader');
        }
        return;
    }
    const modalBody = container.querySelector('#modal-body');
    modalBody.innerHTML = '<p>Loading…</p>';

    try {
        setModalContent(modalBody, await fetchProductInfoFragment(url));
        // initialize any JS in that new markup (e.g. option-pickers)
        initProductForm(modalBody);
        openModal();
    } catch(err) {
        modalBody.innerHTML = '<p>Sorry, could not load product.</p>';
        console.error(err);
    } finally {
        if (loader) {
            loader.textContent = originalLabel;
            loader.classList.remove('bundle-atc-loader');
        }
    }
}

$(document).on('click', '.add-bundle-to-cart, [data-product-card-modal-trigger]', async (e) => {
    await openProductCardModal(e.currentTarget);
})

const cardModalClickIgnoreSelector = 'a, button, input, select, textarea, label, .quick-add, [data-quick-add-button], [data-product-card-modal-trigger], .add-bundle-to-cart, product-info-button, .card__option-colors';

function triggerProductCardModalFromZone(zone) {
    if (!zone?.dataset?.handle) return;
    openProductCardModal(zone);
}

$(document).on('click', '[data-product-card-click-modal]', async (e) => {
    if ($(e.target).closest(cardModalClickIgnoreSelector).length) return;
    const zone = e.currentTarget;
    if (!zone.matches('[data-product-card-click-modal]')) return;
    e.preventDefault();
    await triggerProductCardModalFromZone(zone);
});

$(document).on('keydown', '[data-product-card-click-modal]', async (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if ($(e.target).closest(cardModalClickIgnoreSelector).length) return;
    e.preventDefault();
    await triggerProductCardModalFromZone(e.currentTarget);
});

$(document).on('click', '.bundle-product-card .card__inner', (e) => {
    const parent = e.currentTarget.closest('.bundle-product-card');
    if (parent) {
        const btn = parent.querySelector('.learn-more-btn--bundle');
        if (btn) {
            btn.click();
        }
    }
})
$(document).on('click', '.bundle-product-card .card__information', (e) => {
    const parent = e.currentTarget.closest('.bundle-product-card');
    if (parent) {
        const btn = parent.querySelector('.learn-more-btn--bundle');
        if (btn) {
            btn.click();
        }
    }
})

$(document).on('click', '.learn-more-btn--bundle', async (e) => {
    const btn = e.currentTarget;
    const loader = btn.querySelector('span');
    if (loader) {
        loader.innerHTML = 'Loading...';
    };
    const handle = e.currentTarget.dataset.handle;
    const url = `/products/${handle}`;
    const container = document.querySelector('#product-modal');
    const modalBody = container.querySelector('#modal-body');
    modalBody.innerHTML = '<p>Loading…</p>';
    try {
        setModalContent(modalBody, await fetchProductInfoFragment(url));
        initProductForm(modalBody);
        openModal();
    } catch(err) {
        modalBody.innerHTML = '<p>Sorry, could not load product.</p>';
        console.error(err);
    } finally {
        if (loader) {
            loader.innerHTML = 'Learn more';
        };
    }
})

$(document).on('click', '.modal-content .read-more-less__button', (e) => {
    const isReadMore = e.currentTarget.classList.contains('js-read-more');

    const parent = e.currentTarget.closest('.js-read-more-less');
    if (!parent) return;

    let shortDescription = parent.querySelector(".js-short-description");
    let fullDescription = parent.querySelector(".js-full-description");
    if (!shortDescription || !fullDescription) return;

    if (isReadMore) {
        shortDescription.classList.add("hidden");
        fullDescription.classList.remove("hidden");
    } else {
        shortDescription.classList.remove("hidden");
        fullDescription.classList.add("hidden");
    }
})

class SubscriptionQuickadd extends HTMLElement {
    constructor() {
        super();
        this.variantSelect = this.querySelector('.js-variant-select');
        this.purchaseOption = this.querySelector('.js-selling-plan-selector');
        this.addToCartBtn = this.querySelector('.js-add-subscription-to-cart');
        this.popupBtn = this.querySelector('.js-open-popup');
        this.popup = this.querySelector('.featured-subscription-popup');
        this.popupCloseBtn = this.querySelector('.js-close-popup');
        this.popupOverlay = this.querySelector('.featured-subscription-popup-overlay');

        this.initEventListeners();
    }

    initEventListeners() {
        if(this.popupBtn) {
            this.popupBtn.addEventListener('click', (e) => {
                this.popup.classList.add('open');
                document.body.style.overflow = 'hidden';
            });
        }
        if(this.popupCloseBtn) {
            this.popupCloseBtn.addEventListener('click', (e) => {
                this.popup.classList.remove('open');
                document.body.style.overflow = 'scroll';
            });
        }
        if(this.popupOverlay) {
            this.popupOverlay.addEventListener('click', (e) => {
                this.popup.classList.remove('open');
                document.body.style.overflow = 'scroll';
            });
        }
        if(this.variantSelect) {
            this.variantSelect.addEventListener('change', (e) => {
                this.variantSelect.value = e.target.value;
                const variantId = e.target.value;
                let atcBtnText = this.addToCartBtn.dataset.atcText;
                const variantImgUrl = e.target.options[e.target.selectedIndex].dataset.variantImage;
                this.updateVariantImage(variantImgUrl);
                this.updateChosenVariant(variantId);     
                if(this.variantSelect.value == "") {
                    this.disableATCBtn();
                    atcBtnText = "Choose flavour";
                } else {
                    if(this.purchaseOption) {
                        this.purchaseOption.disabled = false;
                        if(this.purchaseOption.value != "") {
                            this.enableATCBtn();
                        } else {
                            this.disableATCBtn();
                            atcBtnText = "Choose frequency";
                        }
                    } else {
                        this.enableATCBtn();
                    }
                }
                this.updateATCText(atcBtnText);
            });
        }
        if(this.purchaseOption) {
            this.purchaseOption.addEventListener('change', (e) => {
                const sellingPlan = e.target.value;
                let atcBtnText = this.addToCartBtn.dataset.atcText;
                if(sellingPlan == "") {
                    this.disableATCBtn();
                    atcBtnText = "Choose frequency";
                } else {
                    if(sellingPlan != 'one-time-purchase') {
                        this.updateSellingPlan(sellingPlan);
                    } else {
                        this.updateSellingPlan("");
                    }
                    if(this.variantSelect) {
                        if(this.variantSelect.value != "") {
                            this.enableATCBtn();
                        } else {
                            this.disableATCBtn();
                            atcBtnText = "Choose flavour";
                        }
                    } else {
                        this.enableATCBtn();
                    }
                }
                this.updateATCText(atcBtnText);

                // update price
                const wrapper = this.closest('.card-information-subscription');
                if (wrapper) {
                    const priceElem = wrapper.querySelector('.price');
                    if (priceElem) {
                        const regularPrice = priceElem.getAttribute('data-regular-price');
                        const fullPrice = priceElem.getAttribute('data-price');
                        const discount = e.target.options[e.target.selectedIndex].getAttribute('data-saving');

                        if (discount) {
                            priceElem.innerHTML = `<strong><span class="u-text-green">${Shopify.formatMoney(fullPrice * (100 - +discount) / 100)}</span>  <span class="u-linethrough">${regularPrice}</span></strong>`;
                        } else {
                            priceElem.innerHTML = `<strong>${regularPrice}</strong>`;
                        }
                    }
                }
            });
        }
        if(this.addToCartBtn) {
            this.addToCartBtn.addEventListener('click', (e) => {
                const variantId = e.target.dataset.variantId;
                const sellingPlanId = e.target.dataset.sellingPlan;
                this.addToCart(variantId, sellingPlanId);
            })
        }
    }

    updateATCText(atcBtnText) {
        if(this.addToCartBtn) {
            this.addToCartBtn.textContent = atcBtnText;
        }
    }

    updateVariantImage(variantImgUrl) {
        const cardParent = this.closest('.card-wrapper');
        const productImageEl = cardParent.querySelector('.card__media img');
        if(productImageEl) {
            productImageEl.srcset = "";
            productImageEl.src = 'https:' + variantImgUrl;
        }
    }

    updateChosenVariant(variantId) {
        if(this.addToCartBtn) {
            this.addToCartBtn.dataset.variantId = variantId;
        }
    }

    updateSellingPlan(sellingPlanId) {
        if(this.addToCartBtn) {
            this.addToCartBtn.dataset.sellingPlan = sellingPlanId;
        }
    }

    enableATCBtn() {
        if(this.addToCartBtn) {
            this.addToCartBtn.disabled = false;
        }
    }

    disableATCBtn() {
        if(this.addToCartBtn) {
            this.addToCartBtn.disabled = true;
        }
    }

    async addToCart(variantId, sellingPlan) {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = "Adding...";

        let formdata = {
            id: variantId,
            quantity: 1
        }
        if(sellingPlan) {
            formdata = {
                id: variantId,
                quantity: 1,
                selling_plan: sellingPlan
            }
        }
        try {
            const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(formdata)
            });

            const data = await response.json();
            loadCartAPI(true);
        } catch (err) {
            console.error('Add to cart failed', err);
            alert('There was an error adding the product to the cart.');
        }  finally {
            this.addToCartBtn.disabled = false;
            this.addToCartBtn.textContent = this.addToCartBtn.dataset.atcText;
        }
    }
}
customElements.define('subscription-quickadd', SubscriptionQuickadd);

class CustomBundles extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Run when the element is added to the DOM
       this.initEventListeners();
       this.updateBundleInfo();
       
       const uniqueBundleId = document.getElementById('bundle-id');
        if (uniqueBundleId) {
          uniqueBundleId.value = Date.now();
        }
    }

    initEventListeners() {
        const dropdowns = this.querySelectorAll('[data-drawer-button]');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', (e) => {
                const parent = e.target.closest('.radio-button-wrapper');
                if (parent) {
                    parent.classList.toggle('open');
                }
                document.body.classList.toggle('bundle-drawer-open');
                document.querySelector('#shopify-section-header').classList.add('shopify-section-header-hidden');
            });
        });
        const variantRadioButtons = this.querySelectorAll('[data-radio-buttons]');
        variantRadioButtons.forEach(radio => {
            radio.addEventListener('change', (event) =>{
                if (event.target.type === 'radio') {
                    const parent = event.target.closest('.radio-button-container');
                    const imgSrc = parent.querySelector('img').getAttribute('src');
                    const title = parent.querySelector('[data-title-complete]').getAttribute('data-title-complete');
                    const mainParent = parent.closest('.radio-button-wrapper');
                    this.updateChosenVariant(mainParent, imgSrc, title);
                    this.closeAll();
                }
            });
        });
        const backdrops = document.querySelectorAll('.backdrop');
        backdrops.forEach((backdrop) => {
            backdrop.addEventListener('click', (e) => {
                this.closeAll();
            })
        });
        const closeBtns = this.querySelectorAll('.drawer__close');
        closeBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                this.closeAll();
            });
        });
    }

    updateChosenVariant(parent, imgSrc, title) {
        const selectedImage = parent.querySelector('img');
        const selectedTitle = parent.querySelector('div');
        if (selectedImage) {
            selectedImage.setAttribute('src', imgSrc);
        }
        if (selectedTitle) {
            selectedTitle.textContent = title;
        }
        this.updateBundleInfo();
    }

    updateBundleInfo() {
        const bundleInputContent = document.querySelector('#bundle-contents');
        const bundleInputContentProducts = document.querySelector('#bundle-contents-products');
        const bundleInputItemsFree = document.querySelector('#bundle-items-free');
        const bundleInputContentPrices = document.querySelector('#bundle-contents-prices');
        const selectedVariantIds = [];
        const selectedProductIds = [];
        const selectedItemsFree = [];
        const selectedItemPrices = [];
        const selectedVariants = Array.from(this.querySelectorAll('input[type="radio"]:checked'));

        // Every bundle attribute comes from this ordered selection so the cart transform can match each price to its variant and free flag.
        selectedVariantIds.push(...Array.from(selectedVariants).map(radio => radio.value));
        selectedProductIds.push(...Array.from(selectedVariants).map(radio => radio.dataset.productId));
        selectedItemsFree.push(...Array.from(selectedVariants).map(radio => radio.dataset.bundleItemFree));
        selectedItemPrices.push(...Array.from(selectedVariants).map(radio => radio.dataset.bundleItemPrice));

        if ( bundleInputContent ) { 
            bundleInputContent.value = selectedVariantIds;
        }
        if ( bundleInputContentProducts ) {
            bundleInputContentProducts.value = selectedProductIds;
        }
        if( bundleInputItemsFree ) {
            bundleInputItemsFree.value = selectedItemsFree;
        }
        if (bundleInputContentPrices) {
            bundleInputContentPrices.value = selectedItemPrices;
        }
    }

    closeAll() {
        const buttons = this.querySelectorAll('[data-drawer-button]');
        buttons.forEach((button) => {
            button.closest('.radio-button-wrapper').classList.remove('open');
        });
        document.body.classList.remove('bundle-drawer-open');
    }
}
customElements.define('custom-bundles', CustomBundles);

// Image Switcher
window.addEventListener('DOMContentLoaded', () => {
    $(document).on('click', '.image-switcher__button', (e) => {
        const btn = e.currentTarget;
        if (btn.classList.contains('active')) return;

        const id = btn.getAttribute('data-id');
        if (!id) return;

        const parent = btn.closest('.image-switcher');
        if (!parent) return;

        const btns = parent.querySelectorAll('.image-switcher__button');
        const images = parent.querySelectorAll('.image-switcher__image-wrapper');
        if (!btns || !images) return;

        // update new active button
        btns.forEach(elem => {
            elem.classList.remove('active');
        });
        btn.classList.add('active');

        // update new active image
        images.forEach(elem => {
            elem.classList.remove('active')
        })
        images.forEach(elem => {
            if (elem.getAttribute('data-id') == id) {
                elem.classList.add('active');
            }
        })
    })
})
  
$(document).on('click', '.discount-code-box__wrapper', (e) => {
    e.preventDefault();
    const code = e.currentTarget.querySelector('.discount-code-box');
    if (!code) return;
    const copyText = code.innerText;
    navigator.clipboard.writeText(copyText);

    // Alert the copied text
    const wrapper = e.currentTarget.closest('.discount-code-box__wrapper-wrapper');
    if (!wrapper) {
        alert("Copied to clipboard: " + copyText);
    } else {
        const alert = document.createElement('span');
        alert.innerHTML = "Code Copied!";
        alert.classList.add('discount-code-alert')
        wrapper.appendChild(alert);

        setTimeout(() => {
            wrapper.removeChild(alert);
        }, 2500);
    }
})

class ProductInfoButton extends HTMLElement {
    constructor() {
        super();
        this.el = this;
        this.id = this.el.dataset.productId;
        this.handle = this.el.dataset.productHandle;

        this.popup = null;
        this.layout = null;

        this.addingToCart = false;

        this.init();
    }

    init() {
        this.layout = document.querySelector('main');
        this.el.addEventListener('click', this._handleClick);

        // trigger popup on other card elements
        const parent = this.el.closest('.card-wrapper');
        if (parent) {
            const cardImg = parent.querySelector('.card__inner');
            if (cardImg) {
                cardImg.addEventListener('click', () => {this.el.click()});
            }
            const cardInfo = parent.querySelector('.card__information');
            if (cardInfo) {
                cardInfo.addEventListener('click', () => {this.el.click()});
            }
        }
    }

    async _queryProduct() {
        const url = `${window.shopUrl}/api/2025-10/graphql.json`;

        const query = `
            query Product($id: ID!) {
                product(id: $id) {
                    id
                    handle
                    availableForSale
                    descriptionHtml
                    featuredImage {
                        url
                    }
                    directions: metafield (namespace: "details", key: "directions") {
                        value
                    }
                    ingredients: metafield (namespace: "details", key: "ingredients") {
                        value
                    }
                    oneliner: metafield (namespace: "details", key: "oneliner") {
                        value
                    }
                    faq: metafield (namespace: "details", key: "faq") {
                        value
                    }
                    tags
                    title
                    variants (first: 20) {
                        nodes {
                            availableForSale
                            compareAtPrice {
                                amount
                            }
                            id
                            price {
                                amount
                            }
                            quantityAvailable
                            title
                        }
                    }
                }
            }
        `;

        const variables = {
            id: `gid://shopify/Product/${this.id}`
        };

        const requestBody = JSON.stringify({
            query: query,
            variables: variables
        });

        let productData = null;

        productData = fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'f5d40983870c7ad9a82f41761b3110dc'
            },
            body: requestBody
        })
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error('Error fetching GraphQL data:', error);
        });

        return productData;
    }

    _buildPopup(product) {
        let html = '';

        // close btn
        const closeBtn = `
            <button class="product-info-popup__close" type="button">×</button>
        `;
        html += closeBtn;

        if (product.title) {
            let title = product.title;
            // let title_arr = product.title.split(' - ');
            // if (title_arr[1]) {
            //     title = title_arr.join('<br/>')
            // }
            html += `<h3 class="pip__title">${title}</h3>`;
        }
        if (product.oneliner) {
            html += `<p class="pip__oneliner">${product.oneliner.value}</p>`;
        }
        if (product.variants?.nodes?.[0]) {
            const variant = product.variants?.nodes?.[0];

            html += `
                <div class="pip__price-wrapper">
            `;

            let discount = '';
            if (variant.compareAtPrice?.amount) {
                let diff = variant.compareAtPrice.amount - variant.price.amount;
                discount = `${Math.ceil((diff / variant.compareAtPrice.amount) * 100)}% OFF`;

                html += `
                    <span class="pip__compare-at">${Shopify.formatMoney(variant.compareAtPrice.amount * 100)}</span>
                `;
            }

            html += `
                    <span class="pip__price">${Shopify.formatMoney(variant.price.amount * 100)}</span>
            `;

            if (discount != '') {
                let diff = variant.compareAtPrice.amount - variant.price.amount;
                let discountVal = Math.round((diff / variant.compareAtPrice.amount) * 100);
                discount = `${Math.round((diff / variant.compareAtPrice.amount) * 100)}% OFF`;

                html += `
                    <span class="pip__discount${discountVal >= 50 ? ' hot' : ''}">${discount}</span>
                `;
            }

            html += `
                </div>
            `;
        }
        if (product.descriptionHtml) {
            html += `
                <details>
                    <summary>
                        Description 
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.953735 6.27539L11.5964 6.27539" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.27505 0.954102L6.27505 11.5968" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </summary>
                    <div>
                        ${product.descriptionHtml}
                    </div>
                </details>
            `;
        }
        if (product.directions) {
            html += `
                <details>
                    <summary>
                        Directions 
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.953735 6.27539L11.5964 6.27539" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.27505 0.954102L6.27505 11.5968" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </summary>
                    <div>
                        ${product.directions.value}
                    </div>
                </details>
            `;
        }
        if (product.faq) {
            html += `
                <details>
                    <summary>
                        FAQs 
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.953735 6.27539L11.5964 6.27539" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.27505 0.954102L6.27505 11.5968" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </summary>
                    <div>
                        ${product.faq.value}
                    </div>
                </details>
            `;
        }
        if (product.ingredients) {
            html += `
                <details>
                    <summary>
                        Ingredients 
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.953735 6.27539L11.5964 6.27539" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.27505 0.954102L6.27505 11.5968" stroke="#33363F" stroke-width="1.90749" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </summary>
                    <div>
                        ${product.ingredients.value}
                    </div>
                </details>
            `;
        }

        if (html != '') {
            html += `
                <button
                    type="button"
                    class="button pip__add-to-cart"
                    data-product-id="${product.id.split('/').pop()}"
                    data-variant-id="${product.variants?.nodes?.[0].id.split('/').pop()}"
                    ${product.availableForSale ? '' : 'disabled'}
                >
                    ${product.availableForSale ? 'ADD TO CART' : 'OUT OF STOCK'}
                </button>
            `;

            html += `
                <button
                    type="button"
                    class="button pip__back-to-sale"
                >
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.71293 0.544922L1.08972 5.16813L5.71293 9.79134" stroke="white" stroke-width="1.54107"/>
                    </svg>    
                    BACK TO SALE
                </button>
            `;
        }
        
        return html;
    }

    async _openPopup() {
        // TODO: remove any popup currently active if exists
        const existingPopup = document.querySelector('#product-info-popup');
        if (existingPopup) {
            existingPopup.remove();
        }

        const template = `
            <div class="product-info-popup__inner with-spinner">
                <div class="spinner"></div>
            </div>
        `;

        const popup = document.createElement('div');
        popup.classList.add('product-info-popup');
        popup.setAttribute('id', 'product-info-popup');
        popup.innerHTML = template;

        // const layout = document.querySelector('main');
        this.layout.appendChild(popup);

        // disable page scroll
        const body = document.querySelector('body');
        body.classList.add('modal-open');

        return popup;
    }

    async _addToCart(variantId, btn) {
        if (this.addingToCart) return;
        this.addingToCart = true;

        btn.disabled = true;
        btn.textContent = "Adding...";

        let formdata = {
            id: variantId,
            quantity: 1
        }
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(formdata)
            });

            const data = await response.json();
            loadCartAPI(true);
        } catch (err) {
            console.error('Add to cart failed', err);
            alert('There was an error adding the product to the cart.');
        } finally {
            btn.disabled = false;
            btn.textContent = 'Add To Cart';
            this.addingToCart = false;
        }
    }

    _addEventListeners() {
        // Accordions
        const accordions = this.popup.querySelectorAll('details');
        accordions.forEach(accordion => {
            accordion.addEventListener('click', (e) => {
                if (accordion.hasAttribute('open')) return;
                e.preventDefault();

                accordions.forEach(acc => {
                    acc.removeAttribute('open')
                })

                accordion.setAttribute('open', 'open');
            })
        })

        // Back To Sale
        const bts = this.popup.querySelector('.pip__back-to-sale');
        if (bts) {
            bts.addEventListener('click', (e) => {
                // const layout = document.querySelector('main');
                // this.layout.removeChild(this.popup);
                this.popup.remove();

                // enable page scroll
                const body = document.querySelector('body');
                body.classList.remove('modal-open');
            })
        }

        // Close Button
        this.popup.addEventListener('click', (e) => {
            if (e.target.classList.contains('product-info-popup__close')) {
                // const layout = document.querySelector('main');
                // this.layout.removeChild(this.popup);
                this.popup.remove();

                // enable page scroll
                const body = document.querySelector('body');
                body.classList.remove('modal-open');
            }
        })

        // Background Close
        this.popup.addEventListener('click', (e) => {
            if (e.target.classList.contains('product-info-popup')) {
                // const layout = document.querySelector('main');
                // this.layout.removeChild(this.popup);
                this.popup.remove();

                // enable page scroll
                const body = document.querySelector('body');
                body.classList.remove('modal-open');
            }
        })

        // Add To Cart
        const atc = this.popup.querySelector('.pip__add-to-cart');
        if (atc) {
            atc.addEventListener('click', async (e) => {
                atc.setAttribute('disabled', 'disabled')
                const varId = atc.getAttribute('data-variant-id');
                await this._addToCart(varId, atc);

                // close popup
                // const layout = document.querySelector('main');
                // this.layout.removeChild(this.popup);
                this.popup.remove();

                // enable page scroll
                const body = document.querySelector('body');
                body.classList.remove('modal-open');
            })
        }
    }

    async _handleClick() {
        console.log('_handleClick()')
        if (!this.id || !this.handle) return;

        // Open popup with loading spinner
        const popup = await this._openPopup();
        if (!popup) return;

        this.popup = popup;

        const popupContainer = popup.querySelector('.product-info-popup__inner');
        if (!popupContainer) return;

        // Get product data
        const data = await this._queryProduct()
        if (!data || data.errors || !data.data?.product) {
            console.error(`Error retrieving product data: ${this.id}`);
        
            const html = `
                <button class="product-info-popup__close" type="button">×</button>
                <div>Information not available.</div>
            `;
            
            popupContainer.innerHTML = html;

            this._addEventListeners();

            return;
        }

        const popupHtml = this._buildPopup(data.data.product);
        if (!popupHtml) {
            popupContainer.innerHTML = `There was an error showing product information. Please try again.`;

            return;
        };

        popupContainer.innerHTML = popupHtml;
        popupContainer.classList.remove('with-spinner');

        this._addEventListeners();
    }
}
customElements.define('product-info-button', ProductInfoButton);
